<app-drawer-layout title="Available Balance" [state]="layoutState()">
  <!-- Single-root @if blocks so the stat is projected into the header's trailing slot. -->
  @let groupPage = categoryPageQuery.data();
  @if (groupPage) {
    <app-drawer-stat drawerTrailing [amount]="groupPage.unbudgeted.unbudgeted" label="Balance" />
  }
  @if (groupPage) {
    <div class="flex flex-col gap-6">
      <p class="m-0 text-body-sm text-text-muted">
        @if (groupPage.unbudgeted.unbudgeted < 0) {
          Your calculated available balance is below zero. Review the account balances, budget balances, and
          transaction adjustments below.
        } @else if (groupPage.unbudgeted.unbudgeted > 0) {
          This money is available to assign to your budgets.
        } @else {
          Your calculated available balance is zero.
        }
      </p>

      <app-drawer-section heading="How this adds up">
        <dl class="m-0 divide-y divide-border-muted">
          @for (row of balanceBreakdown(); track row.label) {
            <div class="flex items-baseline justify-between gap-4 px-4 py-3">
              <dt class="min-w-0 text-body-sm text-text-muted">
                {{ row.label }}
                @if (row.hint) {
                  <span class="mt-0.5 block text-xs text-text-subtle">{{ row.hint }}</span>
                }
              </dt>
              <dd class="m-0 shrink-0 whitespace-nowrap text-body-sm font-semibold tabular-nums text-text-title">
                {{ row.amount > 0 ? '+' : '' }}{{ row.amount | currency: 'USD' : 'symbol' : '1.2-2' }}
              </dd>
            </div>
          }
          <div class="flex items-baseline justify-between gap-4 px-4 py-3">
            <dt class="text-body-base font-bold text-text-title">
              {{ groupPage.unbudgeted.unbudgeted < 0 ? 'Shortfall' : 'Available to assign' }}
            </dt>
            <dd
              class="m-0 shrink-0 whitespace-nowrap text-body-base font-bold tabular-nums"
              [class.text-status-danger]="groupPage.unbudgeted.unbudgeted < 0"
              [class.text-text-title]="groupPage.unbudgeted.unbudgeted >= 0"
            >
              {{ groupPage.unbudgeted.unbudgeted | currency: 'USD' : 'symbol' : '1.2-2' }}
            </dd>
          </div>
        </dl>
      </app-drawer-section>

      @if (groupPage.unbudgeted.unbudgeted !== 0) {
        <app-drawer-section [padded]="true">
          <app-transfer-budget
            [padded]="false"
            [options]="{
              initialAmount: getInitialAmount(groupPage),
              hideTransferIn: groupPage.unbudgeted.unbudgeted > 0,
              hideTransferOut: groupPage.unbudgeted.unbudgeted < 0,
              allowNegativeAmount: groupPage.unbudgeted.unbudgeted > 0,
            }"
            (transferSuccess)="handleTransferSuccess($event)"
          />
        </app-drawer-section>
      }
    </div>
  }
</app-drawer-layout>
